import axios from "axios"
import { requestApi } from "./axiosHelper"

const rootUrl = process.env.REACT_APP_API_ROOT_URL
const userProfile = rootUrl + "/user"
const logoutUrl = rootUrl + "/user/logout"
const newAccessJWTUrl = rootUrl + "/token"
const confirmResApi = rootUrl + "/emailconfirm"

export const CreateRegisterAPI = async (formDt) => {
  try {
    const axiosData = {
      url: userProfile,
      method: "post",
      data: formDt,
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)

    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}

export const fetchUser = async () => {
  try {
    const axiosData = {
      url: userProfile,
      method: "get",
      body: null,
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)

    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}
export const updateUser = async (obj) => {
  try {
    const axiosData = {
      url: userProfile,
      method: "patch",
      data: obj,
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)
    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}
export const fetchAllAdminUser = async () => {
  try {
    const axiosData = {
      url: userProfile + "/all-staffs",
      method: "get",
      body: null,
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)
    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}

export const deleteUser = async (_id) => {
  try {
    const axiosData = {
      url: `${userProfile}/${_id}`,
      method: "delete",
    }
    const sendAuth = true
    const data = await requestApi(axiosData, sendAuth)
    return data
  } catch (error) {
    return error.response?.data || { status: "error", message: error.message }
  }
}

export const fetchNewAccessJWT = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const { refreshJWT } = JSON.parse(localStorage.getItem("refreshJWT"))
      if (!refreshJWT) {
        reject("Token not found")
      }

      const data = await axios.get(newAccessJWTUrl, {
        headers: {
          Authorization: refreshJWT,
        },
      })

      if (data.status === "success") {
        sessionStorage.setItem("accessJWT", data.accessJWT)
      }

      resolve(true)
    } catch (error) {
      if (error.message === "Request failed with status code 403") {
        localStorage.removeItem("refreshJWT")
      }
      console.log(error.message)
      reject(false)
    }
  })
}

export const userLogout = async (_id) => {
  try {
    const { data } = await axios.post(logoutUrl, { _id })
    return data
  } catch (error) {
    console.log(error.message)
  }
}

export const confirmRegisterAPI = (formDt) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axios.post(confirmResApi, formDt)
      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}
